import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'

// A file_path is usable only if it's non-empty and not a leftover browser "fakepath".
export const isFileAvailable = (fp) => {
    const f = (fp || "").trim();
    return f !== "" && !f.toLowerCase().includes("fakepath");
};

class PDFModel extends Component {
    render() {
        const { file_path, file_name, show, onHide } = this.props;
        const valid = isFileAvailable(file_path);

        return (
            <Modal show={show} onHide={onHide} size="lg" centered dialogClassName="rm-pdf-modal" aria-labelledby="rm-pdf-title">
                <div className="rm-pdf-head">
                    <div className="rm-pdf-head-title">
                        <span className="rm-pdf-head-icon"><i className="fas fa-file-pdf"></i></span>
                        <div className="rm-pdf-head-text">
                            <h6 title={file_name}>{file_name ? file_name : "Revision Material"}</h6>
                            <span>PDF Document</span>
                        </div>
                    </div>
                    <div className="rm-pdf-head-actions">
                        {valid ? (
                            <a href={file_path} target="_blank" rel="noopener noreferrer" download className="rm-pdf-download">
                                <i className="fas fa-download mr-1"></i> Download
                            </a>
                        ) : ("")}
                        <button type="button" className="rm-pdf-close" onClick={onHide} aria-label="Close">
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                </div>
                <Modal.Body className="rm-pdf-body">
                    {valid ? (
                        <iframe title={file_name ? file_name : "pdf-viewer"} src={file_path} className="rm-pdf-frame"></iframe>
                    ) : (
                        <div className="rm-pdf-empty">
                            <i className="fas fa-exclamation-circle"></i>
                            <h6>File not available</h6>
                            <p>This material hasn't been uploaded correctly yet. Please check back later.</p>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        )
    }
}

export default PDFModel
